export default "__VITE_ASSET__BMkQaIHb__"